import {
    StyleSheet
} from "react-native";
import type {
    TraceLineColorsConstantType,
    TraceLineColors
} from "./type";

export const getTraceLineColors = ({
    isActive,
    colors,
    status
}: TraceLineColorsConstantType): TraceLineColors => {
    const {
        content
    } = colors;

    const restTitleColor = isActive ? content.text.high : content.text.mid;

    const restIconColor = isActive ? content.icon.high : content.icon.mid;

    const descriptionColor = isActive ? content.text.mid : content.text.low;

    if(status === "running") {
        return {
            titleColor: content.text.high,
            iconColor: content.icon.mid,
            descriptionColor
        };
    }

    if(status === "error") {
        return {
            titleColor: content.text.danger,
            iconColor: content.icon.danger,
            descriptionColor
        };
    }

    if(status === "pending") {
        return {
            titleColor: content.text.low,
            iconColor: content.icon.low,
            descriptionColor
        };
    }

    if(status === "cancelled") {
        return {
            iconColor: content.icon.low,
            titleColor: restTitleColor,
            descriptionColor
        };
    }

    return {
        titleColor: restTitleColor,
        iconColor: restIconColor,
        descriptionColor
    };
};

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        alignItems: "stretch",
        minWidth: 0
    }
});
export default stylesheet;
